import { GQL_WhitelistedDomain } from '../../types/whitelistedDomain';

export const isEmailWhiteListed = (email: string, whitelistedDomains: GQL_WhitelistedDomain[]): boolean => {
  // check if the email's domain is whitelisted
  if (whitelistedDomains.some((domain) => email.endsWith(domain.domain))) return true;

  return false;
};
